import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportPastDueAccountsByAccountOfficer from "../reports/ReportPastDueAccountsByAccountOfficer";


function PastDueAccountsByAccountOfficer() {
    return (
        <>
            <NavMain slug="past-due-accounts-by-account-officer" parent="3" />
            <HeaderMain slug="past-due-accounts-by-account-officer" />
            <div className="main-content">
                <ReportPastDueAccountsByAccountOfficer />
            </div>
        </>
    );
}

export default PastDueAccountsByAccountOfficer;